<template lang="pug">
aside.drawer.is-hidden-tablet(:class="{ 'is-opened': drawer }")
  .menu-wrapper
    a.button.is-black(@click="toggleDrawer")
      b-icon(icon="close")
    .menu
      ul.menu-list
        li
          router-link(
            :to="{ name: 'home' }"
            :class="{ 'is-active': activePage === 'home' }"
          )
            span {{ account.organization }}
        li
          router-link(
            :to="{ name: 'services' }"
            :class="{ 'is-active': activePage === 'services' || activePage === 'episode' }"
          )
            span Services
        li(v-if="account.abbreviation === 'FFC'")
          router-link(
            :to="{ name: 'tv' }"
            :class="{ 'is-active': activePage === 'tv' }"
          )
            span TV
        li
          router-link(
            :to="{ name: 'calendar', query:{ page:1 } }"
            :class="{ 'is-active': activePage === 'calendar' || activePage === 'event' || activePage === 'eventSignup' }"
          )
           span Calendar
        li
          router-link(
            :to="{ name: 'ministries' }"
            :class="{ 'is-active': activePage === 'ministries' || activePage === 'ministry' }"
          )
            span Ministries
        li
          a(
            href="https://foothill-family-church.myshopify.com/"
            target="_blank"
          )
            span Store
        li
          router-link(
            :to="{ name: 'believe' }"
            :class="{ 'is-active': activePage === 'believe' }"
          )
            span What We Believe
        //- li
        //-   router-link(
        //-     :to="{ name: 'faq' }"
        //-     :class="{ 'is-active': activePage === 'faq' }"
        //-   )
        //-     span FAQ
        li
          router-link(
            :to="{ name: 'times' }"
            :class="{ 'is-active': activePage === 'times' }"
          )
            span Service Times
        li
          router-link(
            :to="{ name: 'staff' }"
            :class="{ 'is-active': activePage === 'staff' }"
          )
            span Pastoral Staff
        li
          router-link(
            :to="{ name: 'contact' }"
            :class="{ 'is-active': activePage === 'contact' }"
          )
            span Contact
        li
          a(
            v-if="account.giving_link"
            :href="account.giving_link"
            target="_blank"
          )
            span Giving
</template>

<script>
import { mapGetters } from 'vuex';
import * as getterTypes from '@/store/types/getters';
import * as mutationTypes from '@/store/types/mutations';

export default {
  name: 'drawer-menu',
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
      channel: getterTypes.GET_CHANNEL,
      drawer: getterTypes.GET_DRAWER,
      page: getterTypes.GET_PAGE,
    }),
    activePage() {
      if (this.$route.name === 'episode' && this.channel !== undefined) {
        if (this.channel.title === 'Television') {
          return 'tv';
        }
        return 'services';
      }
      return this.$route.name;
    },
  },
  data() {
    return {};
  },
  methods: {
    toggleDrawer() {
      this.$store.commit(mutationTypes.SET_DRAWER, !this.drawer);
    },
  },
};
</script>

<style lang="scss" scoped>
// https://codepen.io/equinusocio/pen/wPvvmv

.drawer {
  position: fixed;
  z-index: 99;
  width: 100vw;
  height: 100vh;
  top: 0;
  bottom: 0;
  transform: translateX(150%);
  transition: transform 0.5s cubic-bezier(0.4, 0.0, 0.2, 1);
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  &.is-opened {
    transform: translateX(20%);
    .menu {
      transform: none;
      opacity: 1;
      transition-delay: 300ms;
    }
  }
}
.menu-wrapper {
  contain: content;
  background-color: rgba(10, 10, 10, 0.95);
  box-sizing: border-box;
  padding: 24px;
  overflow: auto;
  height: 100vh;
  -webkit-overflow-scrolling: touch;
}
.menu {
  display: flex;
  flex-flow: column wrap;
  transform: translateX(30%);
  opacity: 0;
  transition: all 500ms cubic-bezier(0.4, 0.0, 0.2, 1);
  transition-delay: 0;
  .menu-list {
    margin-left: -0.5rem;
  }
  li {
    padding: 0.4rem 0;
    a {
      font-size: 1.15rem;
      color: $white-ter;
      &:hover {
        background-color: transparent;
      }
      span {
        padding: 0.5rem;
        border-radius: $border-radius;
      }
      &.is-active {
        &, &:focus, &:active {
          background-color: transparent;
        }
        span {
          border-bottom: 4px solid $primary;
        }
      }
    }
  }
  a.navbar-item:hover, a.navbar-item.is-active, a.navbar-link:hover, a.navbar-link.is-active {
    background-color: transparent;
  }
}
</style>
